import script from "./CookiesConsent.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesConsent.vue?vue&type=script&setup=true&lang=js"

import "./CookiesConsent.vue?vue&type=style&index=0&id=3014e8a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3014e8a1"]])

export default __exports__